import { render, staticRenderFns } from "./ProgramSection.vue?vue&type=template&id=757a5293&scoped=true&"
import script from "./ProgramSection.vue?vue&type=script&lang=ts&"
export * from "./ProgramSection.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramSection.vue?vue&type=style&index=0&id=757a5293&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757a5293",
  null
  
)

export default component.exports